export class AccountDto {
  id: number;
  ucid: string;
  name: string;

  //accountManagerEmail: string;
  primaryContact: string;
  mobilePhone: string;
  email: string;
 // ProjectManagerEmail: string;
  //technicalAccountManagerEmail: string;

}
